var map = {
	"./": 142,
	"./Clutch": 2715,
	"./Clutch.js": 2715,
	"./NewUi": 2716,
	"./NewUi.js": 2716,
	"./OldUi": 2717,
	"./OldUi.js": 2717,
	"./index": 142,
	"./index.js": 142,
	"./style": 870,
	"./style.js": 870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4249;